import type { Schema } from '@cli-types/core-engine/schema.js'

export function collectMissingFieldPropertyErrors(schema: Schema, errors: string[]): void {
  for (const field of schema.fields || []) {
    if (field.type === 'separator') continue
    if (!field.name || !field.type) {
      errors.push(`Field is missing required properties: ${JSON.stringify(field)}`)
    }
  }
}
